import { useEffect } from 'react'
import { useLocation, useHistory, useRouteMatch } from 'react-router-dom'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { getCache } from '@/utils/cache'
import { AUTHENTICATED_2FA_TIME } from '@/modules/Auth/pages/TwoFactorAuth/consts'
import { LOGGED_IN_WITH_MAGIC_LINK } from '@/modules/Auth/pages/MagicLink/consts'

export const use2FAValidation = () => {
  const location = useLocation()
  const history = useHistory()
  const { clinic } = useAuthContext()

  const hasAuthenticated = getCache<number>(AUTHENTICATED_2FA_TIME)
  const shouldUseTwoFactorAuth =
    clinic?.flag?.HabilitarAutenticacaoDoisFatoresLoginPaciente &&
    !hasAuthenticated &&
    !getCache(LOGGED_IN_WITH_MAGIC_LINK)

  const is2FARoute = useRouteMatch({
    path: '/autenticacao-dois-fatores',
    exact: true,
  })

  const isChoiceRoute = useRouteMatch({
    path: '/escolha',
    exact: true,
  })

  useEffect(() => {
    if (shouldUseTwoFactorAuth && !isChoiceRoute && !is2FARoute) {
      history.push('/autenticacao-dois-fatores')
    } else if (is2FARoute && hasAuthenticated) {
      history.push('/')
    }
  }, [
    hasAuthenticated,
    history,
    is2FARoute,
    isChoiceRoute,
    location,
    shouldUseTwoFactorAuth,
  ])
}
